import { MAX_LINES } from "../../../AiToolboxSection.constants";

export function getVisualLineCount(containerElem: HTMLDivElement | null): number {
  if (!containerElem) return 0;
  const lines = containerElem.querySelector(".view-lines")?.children.length ?? 0;
  return Math.min(lines, MAX_LINES);
}
